import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

export interface FileXlsxIconOutlinedProps extends SvgIconProps {}

export function FileXlsxIconOutlined(props: FileXlsxIconOutlinedProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 60 61'
      fontSize='inherit'
    >
      <g>
        {/* Excel icon paths */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M28.125 37.625C29.1605 37.625 30 38.4645 30 39.5V48.875H34.6875C35.723 48.875 36.5625 49.7145 36.5625 50.75C36.5625 51.7855 35.723 52.625 34.6875 52.625H28.125C27.0895 52.625 26.25 51.7855 26.25 50.75V39.5C26.25 38.4645 27.0895 37.625 28.125 37.625Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.0626 38.0001C11.891 37.3788 13.0663 37.5467 13.6876 38.3751L22.1251 49.6251C22.7464 50.4535 22.5785 51.6288 21.7501 52.2501C20.9217 52.8714 19.7464 52.7035 19.1251 51.8751L10.6876 40.6251C10.0663 39.7967 10.2342 38.6214 11.0626 38.0001Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.7501 38.0001C22.5785 38.6214 22.7464 39.7967 22.1251 40.6251L13.6876 51.8751C13.0663 52.7035 11.891 52.8714 11.0626 52.2501C10.2342 51.6288 10.0663 50.4535 10.6876 49.6251L19.1251 38.3751C19.7464 37.5467 20.9217 37.3788 21.7501 38.0001Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M43.4371 41.5095C43.2695 41.6532 43.1251 41.8787 43.1251 42.3125C43.1251 42.3346 43.1261 42.3496 43.1272 42.3591C43.1478 42.3811 43.2079 42.4373 43.3477 42.5167C43.7932 42.7696 44.4575 42.953 45.4815 43.225C45.5005 43.23 45.5196 43.2351 45.5389 43.2402C46.4081 43.4709 47.5965 43.7863 48.5539 44.3698C49.6692 45.0494 50.6251 46.1911 50.6251 47.9375C50.6251 49.705 49.8664 51.0828 48.5597 51.9191C47.3889 52.6684 45.9717 52.8594 44.7657 52.8594L44.7608 52.8594C43.0912 52.855 41.4674 52.3137 40.1291 51.3155C39.299 50.6963 39.128 49.5215 39.7471 48.6915C40.3663 47.8614 41.5411 47.6904 42.3711 48.3095C43.0639 48.8262 43.9043 49.1066 44.7684 49.1094C45.6703 49.1091 46.2444 48.9486 46.5382 48.7606C46.6606 48.6823 46.724 48.6067 46.766 48.5272C46.8102 48.4434 46.8751 48.2697 46.8751 47.9375C46.8751 47.9301 46.8752 47.9229 46.8752 47.9159C46.8762 47.8016 46.8767 47.7392 46.6025 47.5721C46.175 47.3116 45.5201 47.1152 44.5188 46.8493C44.4649 46.835 44.4097 46.8204 44.3532 46.8055C43.5156 46.5843 42.3963 46.2887 41.4963 45.7778C40.9834 45.4866 40.4401 45.0737 40.0263 44.4705C39.5959 43.8432 39.3751 43.1106 39.3751 42.3125C39.3751 40.8713 39.9338 39.5733 40.9967 38.6623C42.0288 37.7777 43.3766 37.3906 44.7657 37.3906H44.7707C46.4402 37.395 48.0641 37.9363 49.4024 38.9345C50.2325 39.5537 50.4035 40.7285 49.7843 41.5585C49.1652 42.3886 47.9904 42.5596 47.1603 41.9405C46.4677 41.4238 45.6273 41.1434 44.7633 41.1406C44.0445 41.1411 43.6353 41.3397 43.4371 41.5095Z'
          fill='currentColor'
        />
        {/* Document outline */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.4733 6.84835C11.1766 6.14509 12.1304 5.75 13.125 5.75H35.625C36.1223 5.75 36.5992 5.94754 36.9508 6.29917L50.0758 19.4242C50.4275 19.7758 50.625 20.2527 50.625 20.75V30.125C50.625 31.1605 49.7855 32 48.75 32C47.7145 32 46.875 31.1605 46.875 30.125V21.5267L34.8484 9.5L13.125 9.5L13.125 30.125C13.125 31.1605 12.2855 32 11.25 32C10.2145 32 9.375 31.1605 9.375 30.125V9.5C9.375 8.50544 9.77009 7.55161 10.4733 6.84835Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M35.625 5.75C36.6605 5.75 37.5 6.58947 37.5 7.625V18.875H48.75C49.7855 18.875 50.625 19.7145 50.625 20.75C50.625 21.7855 49.7855 22.625 48.75 22.625H35.625C34.5895 22.625 33.75 21.7855 33.75 20.75V7.625C33.75 6.58947 34.5895 5.75 35.625 5.75Z'
          fill='currentColor'
        />
      </g>
    </SvgIcon>
  );
}
